import {Component, inject} from "@angular/core";
import {MatDialogModule} from "@angular/material/dialog";
import {MatButtonModule} from "@angular/material/button";
import {TranslocoService} from "@jsverse/transloco";
import {DialogBase} from "./dialog.base";
import {Observable} from "rxjs";
import {AsyncPipe} from "@angular/common";

export interface ConfirmDialogData {
    title: Observable<string>;
    message: Observable<string>;
    confirmLabel?: Observable<string>;
    cancelLabel?: Observable<string>;
    destructive?: boolean;
}

@Component({
    templateUrl: "./confirm-dialog.html",
    standalone: true,
    imports: [MatDialogModule, MatButtonModule, AsyncPipe],
})
export class ConfirmDialog extends DialogBase<ConfirmDialogData, boolean> {
    private readonly transloco = inject(TranslocoService);

    protected readonly confirmLabel = this.data.confirmLabel ?? this.transloco.selectTranslate("operations.confirm");
    protected readonly cancelLabel = this.data.cancelLabel ?? this.transloco.selectTranslate("operations.cancel");
}